<template>
  <section class="reading">
    <div class="container container_sec" :class="dayNight">
      <div style="margin-bottom: 9rem">
        <h2 class="reading__title">{{ oneBook }}</h2>
        <!-- <div style="color: black; font-weight: bold">{{ whatLang }}</div> -->
        <span v-for="(ve, idx) in zaToRead" :key="idx">
          <span class="supletter"
            ><sup :class="supClass">{{ ve[0] }}</sup></span
          >
          <span
            :class="zachClass"
            :style="
              idx === currentPop && msg.t
                ? 'color: #0000CD;'
                : idx === currentPop && !msg.t
                ? 'color: #DAA520'
                : ''
            "
            @click="showVerse(ve[0], idx, ve[2])"
            ref="zCoords"
          >
            {{ ve[1] }}
          </span>
          <div class="popup" ref="tooltipWrap" :style="toolWrapStyle">
            <div
              class="popuptext"
              :style="idx === currentPop ? popWidth : ''"
              @click="closePop"
            >
              {{ idx === currentPop ? rusv : '' }}
            </div>
          </div>
          &nbsp;
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TheReading',
  props: {
    msg: Object
  },
  data() {
    return {
      popWidth: '0',
      currentPop: -1,
      isPop: null,
      bottomPos: 0,
      leftPos: 0,
      popBook: null,
      rusv: ''
    }
  },
  computed: {
    dayNight() {
      return this.msg.t ? 'fonday' : 'fonnight'
    },
    // принимаем из App всю книгу, а не по отдельности части
    oneBook() {
      return (
        this.msg.book.boo + ' ' + this.msg.book.z[0] + ' ' + this.msg.book.z[1]
      )
    },
    // whatLang() { // для отображения языка на панели
    //   return this.msg.l === true ? 'cs' : 'rus'
    // },
    // из названия книги и глав(стихов) целый текст для чтения
    zaToRead() {
      let s = this.f(
        this.msg.book.boo,
        this.msg.book.z[1] || this.msg.book.z[0],
        this.msg.l
      )
      return s
    },
    zachClass() {
      return {
        csZach: this.msg.l,
        rusZach: !this.msg.l,
        txtDay: this.msg.t,
        txtNight: !this.msg.t
      }
    },
    supClass() {
      return this.msg.l ? 'csSup' : 'rusSup'
    },
    toolWrapStyle() {
      return `top:${this.bottomPos}px;right:${this.leftPos}px;`
    }
  },
  methods: {
    closePop() {
      this.currentPop = -1
      this.isPop = false
      this.bottomPos = 0
      this.leftPos = 0
    },
    showVerse(numVerse, idx, numCh) {
      if (this.isPop || !this.msg.l) return
      this.rusv = ''
      this.currentPop = idx
      let zachProps = this.$refs.zCoords[idx].getBoundingClientRect()
      let toolWrap = this.$refs.tooltipWrap[idx]
      let tooltipProps = toolWrap.getBoundingClientRect()

      this.bottomPos = 16
      this.leftPos = tooltipProps.left - zachProps.left

      // toolWrap.setAttribute('style', `top:${bottomPos}rem;right:${leftPos}px;`)
      this.popWidth = `visibility:visible;width:${zachProps.width}px`
      this.isPop = true
      let book = this.$store.state[this.popBook]
      this.rusv = `${numVerse}: ${book[numCh]['rus'][numVerse - 1]}`
    },
    expandTire(pair) {
      // на вход типа 2-6
      let twoNums = pair.match(/\d{1,}/g)
      let delta = twoNums[1] - twoNums[0]
      let arra = []
      for (let i = 0; i <= delta; i++) {
        arra.push(i + +twoNums[0])
      }
      // выход 2, 3, 4, 5, 6
      return arra.join(', ')
    },
    feedGlava(lastVerse, lenGlava, p) {
      // вернуть кусок стихов для дополнения главы
      let addArr = []
      for (let m = p; m <= lenGlava - lastVerse; m++) {
        let k = lastVerse + m
        addArr.push(k.toString())
      }
      return addArr
    },
    f(a, b, la) {
      let lang = la ? 'cs' : 'rus'
      // find interested book from complexed "a"
      for (let book of this.$store.state.arrBook) {
        if (a.match(/(?<=\s)Ин.|^Ин./g) && book === 'Ин.') {
          a = book
          this.popBook = book
        } else if (book !== 'Ин.' && a.includes(book)) {
          a = book
          this.popBook = book
        }
      }

      let noZach = false
      if (
        [
          'Иез.',
          'Зах.',
          'Иоил.',
          'Прем._Солом.',
          'Ис.',
          'Иcх.',
          'Быт.',
          'Притч.',
          'Мал.'
        ].includes(a)
      ) {
        noZach = true
      }
      // b = 'XIV, 19–20, 23 – XV, 7.'
      // XXII, 39–42, 45 – XXIII, 1.
      // нужно "растянуть" тире
      // let bb = b
      // пары чисел, разделенные тире, заменяем на последовательности
      let reTire = /\d{1,}–\d{1,}/g
      if (b === 'XIII, 31 – XVIII, 1.') {
        b = 'XIII, 31–38; XIV, 1–31; XV, 1–27; XVI, 1–33; XVII, 1–26; XVIII, 1.'
      }
      if (b === 'I, 1–4; II, 15 – III, 3, 12–13, 15.') {
        b = 'I, 1–4; II, 15; III, 1–3, 12–13, 15.'
      }
      // let y = [...b.matchAll(new RegExp(reTire, 'g'))]
      let y = b.match(reTire)
      let newbb = ''
      // если тире есть
      if (y && y.length) {
        for (let ma of y) {
          let expand = this.expandTire(ma)
          newbb = b.replace(ma, expand)
          b = newbb
        }
      } else {
        // если тире в парах числах нет
        newbb = b
      }
      // главы, содержащие дефис; разделенные точкой с запятой; или просто одиночные главы
      let reSemi = /[A-Z]{1,}.+\d\s–|[A-Z]{1,}.+?\d?;|[A-Z]{1,}.+\d/g
      let zachalo = []
      let ww = 0
      let zstart = '' // номер зачала типа *50, но не *50e(nd) или *50p
      let nostart = false
      let chapters = newbb.match(reSemi)
      for (let el of chapters) {
        let lastChapter = chapters.indexOf(el) === chapters.length - 1
        let eVerse = el.match(/\d+$/g) || [0]
        let ev = +eVerse[0] - 1
        let xx = el.match(/[A-Z]{1,}/g) // всегда одна глава в массиве
        let nums = el.match(/\d{1,}(?!_)/g) // массив стихов (если между главами минус, то первый элемент нужно дополнить влево до 0)
        let glava = this.$store.state[a][xx[0]][lang]
        if (!glava) return
        if (el.includes('–')) {
          ww = 1
          let dopGlava = this.feedGlava(+nums[nums.length - 1], glava.length, 1)
          nums.push(...dopGlava)
        } else if (ww === 1) {
          let dopGlava = this.feedGlava(1, +nums[0] - 1, 0)
          // after first glava, the second should be дополняем сначала
          nums.splice(0, 0, ...dopGlava)
        }
        // перебор глав и сбор массива с номерами и стихами
        glava.forEach((verse, i) => {
          if (nums.includes((i + 1).toString())) {
            if (!la) {
              zachalo.push([i + 1, verse])
            } else {
              let end = verse.match(/\*\d+[px]?(?=e)/g) // последний стих зачала
              if (+nums[0] === i + 1 && zstart === '' && !noZach) {
                let start = verse.match(/\*\d+[pxy]?(?![\dpe])/g) // 1-ый стих зачала
                if (!start) {
                  nostart = true // Лк. 109:43-45 ед. случай
                  zachalo.push([i + 1, verse, xx[0]])
                  return
                }
                zstart = start[0]
                let zach = this.$store.state.zaNo[a][start[0]][1]
                let repl1 = /.*\*\d+[pxy]?(?![\dpe])/
                verse = verse.replace(repl1, zach)
                if (verse.match(/\*\d+[epxyl]?/g)) {
                  verse = verse.replace(/\*\d+[epxyl]?/g, '')
                }
                zachalo.push([i + 1, verse, xx[0]])
                //console.log('1-ый стих', i + 1)
              } else if (
                end &&
                end[0] === zstart &&
                +nums[nums.length - 1] === i + 1
              ) {
                let endVerse = verse.match(/.+(?=[,:.]\*\d+[px]?e)/g)
                let endv = endVerse[0]
                if (endv.match(/\*\d+[epxyl]?/g)) {
                  endv = endv.replace(/\*\d+[epxyl]?/g, '')
                }
                zachalo.push([i + 1, `${endv}.`, xx[0]])
                // console.log('последний стих')
              } else if (verse.match(/\*\d+l\s/g) && !nostart) {
                // delete left part
                let repl2 = /.*\*\d+l\s/g
                verse = verse.replace(repl2, '')
                zachalo.push([i + 1, verse, xx[0]])
              } else if (
                verse.match(/\*\d+r/g) &&
                (zstart === '*110x' ||
                  zstart === '*60x' ||
                  zstart === '*17x' ||
                  zstart === '*44x')
              ) {
                // remove right part
                let repl3 = verse.match(/.+(?=\*\d+r)/g)
                zachalo.push([i + 1, repl3[0], xx[0]])
              } else {
                if (verse.match(/\*\d+[pxylr]?e?/g)) {
                  verse = verse.replace(/\*\d+[pxylr]?e?/g, '')
                }
                if (verse.match(/.$/g)[0] !== '.' && i === ev && lastChapter) {
                  verse = verse.replace(/.$/, '.')
                }
                zachalo.push([i + 1, verse, xx[0]]) // включая пустые стихи и паримии
              }
            }
          }
        })
        // log(zachalo)
      }
      return zachalo
    }
  },
  watch: {
    msg: {
      deep: true,
      handler: function name(params) {
        if (!params.l) {
          this.closePop()
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.reading {
  display: flex;
  &__title {
    text-align: center;
    color: grey;
    margin-bottom: 1.4rem;
  }
  .popup {
    position: relative;
    display: inline-block;
    // top: 0;
    // right: 0;
    // width: 5px;
    // height: 5px;
    // border: 1px solid red;
    // display: flex;
    .popuptext {
      visibility: hidden;
      // width: 34rem;
      font-family: Arial, sans-serif;
      background-color: #555;
      color: #fff;
      text-align: left;
      border-radius: 6px;
      padding: 0.5rem;
      position: absolute;
      z-index: 1;
      font-size: 1.4rem;
    }
  }
}

sup {
  font-size: smaller;
  color: grey;
}

.rusSup {
  vertical-align: middle;
}

.csSup {
  vertical-align: text-top;
}

.rusZach {
  font-family: Arial, sans-serif;
  font-size: 1.5rem;
}

.csZach {
  font-family: 'Hirmos Ucs', sans-serif;
  font-size: 1.75rem;
  letter-spacing: -0.05rem;
}

// phone
@media screen and (min-width: 576px) {
}

// tablet
@media screen and (min-width: 767px) {
  .rusZach {
    font-family: Arial, sans-serif;
    font-size: 1.9rem;
  }
  .csZach {
    font-family: 'Hirmos Ucs', sans-serif;
    font-size: 2.2rem;
  }
}

@media screen and (min-width: 991px) {
}

// как только мы достигаем min 1200px (увеличивая экран) и больше
@media screen and (min-width: 1200px) {
}
</style>
